import QualityGraph from './QualityGraph';

export default QualityGraph;
